module.exports = __webpack_public_path__ + "img/diaceutics-brand-gradients-05.9ba5554f.png";